import * as types from '../actionTypes';

const initialState = {
    headerSettings: {
      title: "",
      subTitle: "",
      avatar: "",
      headerImage: {
        images:{
          small:'',
          medium:'',
          large:''
        }
      }
    },
    backgroundSettings:{
      backgroundColor: "#ffff", 
      backgroundImage: null
    },
    bodySettings:{
      fontColor: '#ffff',
      direction: 'rtl'
    },
    actionsSettings: {
      color:"#ffff",
      textColor:"#ffff",
    },
    detailsSettings:{
      servicesTitle:'שירותים:',
      openingHoursTitle:'שעות פעילות'
    },
    shareSettings:{
      title:'שתפו את כרטיס הביקור באמצעות:'
    },
    footerSettings: {
      title:'כרטיס הביקור נבנה ע"י Smartcard',
      buttonText:"לפרטים נוספים",
      link:'https://www.instagram.com/smart_card_/',
    }
  };

const settingsReducer = (state = initialState,action) => {

    switch(action.type){

        case types.editSetting:
            return{
                ...state,
                [action.payload.level]:{
                    ...state[action.payload.level],
                    [action.payload.setting]: action.payload.value
                }
            };

        default: 
            return state;

    }

}

export default settingsReducer;